import React from 'react';
import Helmet, { HelmetProps } from 'react-helmet';
import { Location } from '@reach/router';

type Props = {
  /** Description text for the description meta tags */
  description?: string;
  metaDescription?: string;
} & HelmetProps;

/**
 * An SEO component that handles all element in the head that can accept
 */
const SEO: React.FC<Props> = ({ children, title, metaDescription }) => {
  return (
    <Location>
      {({ location }) => (
        <Helmet
          htmlAttributes={{
            lang: 'de',
          }}
          title={title}
          titleTemplate="%s"
        >
          <meta name="description" content={metaDescription} />

          {/* OG tags */}
          <meta
            name="og:url"
            content={process.env.GATSBY_SITE_URL + location.pathname}
          />
          <meta name="og:type" content="website" />
          <meta name="og:title" content={title} />
          <meta name="og:description" content={metaDescription} />
          <meta name="og:locale" content="de" />

          {children}
        </Helmet>
      )}
    </Location>
  );
};

export default SEO;
